import img1 from '../../Images/502/502_1.dcm'
import img2 from '../../Images/502/502_2.dcm'
import img3 from '../../Images/502/502_3.dcm'
import img4 from '../../Images/502/502_4.dcm'
import img5 from '../../Images/502/502_5.dcm'
import img6 from '../../Images/502/502_6.dcm'
import img7 from '../../Images/502/502_7.dcm'
import img8 from '../../Images/502/502_8.dcm'
import img9 from '../../Images/502/502_9.dcm'
import img10 from '../../Images/502/502_10.dcm'
import img11 from '../../Images/502/502_11.dcm'
import img12 from '../../Images/502/502_12.dcm'
import img13 from '../../Images/502/502_13.dcm'
import img14 from '../../Images/502/502_14.dcm'
import img15 from '../../Images/502/502_15.dcm'
import img16 from '../../Images/502/502_16.dcm'
import img17 from '../../Images/502/502_17.dcm'
import img18 from '../../Images/502/502_18.dcm'
import img19 from '../../Images/502/502_19.dcm'
import img20 from '../../Images/502/502_20.dcm'
import img21 from '../../Images/502/502_21.dcm'
import img22 from '../../Images/502/502_22.dcm'
import img23 from '../../Images/502/502_23.dcm'
import img24 from '../../Images/502/502_24.dcm'
import img25 from '../../Images/502/502_25.dcm'


//localではdicomweb デプロイ時にはdicomweb



export const dicomT2Wset = [
    'dicomweb:'+ img1,
    'dicomweb:'+ img2,
    'dicomweb:'+ img3,
    'dicomweb:'+ img4,
    'dicomweb:'+ img5,
    'dicomweb:'+ img6,
    'dicomweb:'+ img7,
    'dicomweb:'+ img8,
    'dicomweb:'+ img9,
    'dicomweb:'+ img10,
    'dicomweb:'+ img11,
    'dicomweb:'+ img12,
    'dicomweb:'+ img13,
    'dicomweb:'+ img14,
    'dicomweb:'+ img15,
    'dicomweb:'+ img16,
    'dicomweb:'+ img17,
    'dicomweb:'+ img18,
    'dicomweb:'+ img19,
    'dicomweb:'+ img20,
    'dicomweb:'+ img21,
    'dicomweb:'+ img22,
    'dicomweb:'+ img23,
    'dicomweb:'+ img24,
    'dicomweb:'+ img25,
]